'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactBootstrap = require('react-bootstrap');

var _style = require('./style.scss');

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Navbar(props) {
  return _react2.default.createElement(
    _reactBootstrap.Navbar,
    { fixedTop: true },
    _react2.default.createElement(
      _reactBootstrap.Navbar.Header,
      null,
      _react2.default.createElement(
        _reactBootstrap.Navbar.Brand,
        null,
        _react2.default.createElement(
          'a',
          { href: '#/', className: _style2.default.logo },
          props.title
        )
      ),
      _react2.default.createElement(_reactBootstrap.Navbar.Toggle, null)
    ),
    _react2.default.createElement(
      _reactBootstrap.Navbar.Collapse,
      null,
      _react2.default.createElement(_reactBootstrap.Nav, null),
      _react2.default.createElement(
        _reactBootstrap.Nav,
        { pullRight: true },
        _react2.default.createElement(
          _reactBootstrap.NavDropdown,
          {
            title: _react2.default.createElement('span', { className: 'glyphicon glyphicon-cog', 'aria-hidden': 'true' }),
            noCaret: true,
            id: 'cog-droopdown'
          },
          _react2.default.createElement(
            _reactBootstrap.MenuItem,
            { onClick: props.goPassword },
            '\u66F4\u6539\u5BC6\u78BC'
          ),
          _react2.default.createElement(
            _reactBootstrap.MenuItem,
            { onClick: props.logout },
            '\u767B\u51FA'
          )
        )
      )
    )
  );
}

var string = _propTypes2.default.string,
    func = _propTypes2.default.func;

Navbar.propTypes = {
  title: string.isRequired,
  logout: func.isRequired,
  goPassword: func.isRequired
};

exports.default = Navbar;


//////////////////
// WEBPACK FOOTER
// ./~/coact/components/Main/Navbar/Navbar.js
// module id = 1024
// module chunks = 0